import { ChevronsDownUp } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ToggleChip } from "@/features/identity-hub/components/dashboard/shared/toolbar/ToggleChip";

interface LongTailChipProps {
  active: boolean;
  onToggle: () => void;
  /** How many rows the toggle is folding away, or would fold away if switched on. */
  hiddenCount: number;
  /**
   * `tokenUsageLongTailPercent` from the ops settings. Passed in rather than
   * read here so the chip and the rows it folds away cannot disagree about
   * where the line falls.
   */
  thresholdPercent: number;
}

/**
 * Collapses the rows too small to be part of the answer.
 *
 * The count shows in both states on purpose. A table that quietly drops rows
 * misreports the bill, so the control that dropped them has to say how many —
 * and when it is off, the same number is the reason to switch it on.
 */
export function LongTailChip({
  active,
  onToggle,
  hiddenCount,
  thresholdPercent,
}: LongTailChipProps) {
  const { t } = useTranslation();

  return (
    <ToggleChip
      icon={<ChevronsDownUp className="h-3.5 w-3.5" />}
      label={t("admin.llmUsage.filters.hideLongTail", "Hide under {{percent}}%", {
        percent: thresholdPercent,
      })}
      active={active}
      onClick={onToggle}
      count={hiddenCount}
      title={t(
        "admin.llmUsage.filters.hideLongTailTitle",
        "Hide rows worth less than {{percent}}% of the window. The threshold is set in Settings, under Token usage.",
        { percent: thresholdPercent },
      )}
    />
  );
}
